<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <app-side-nav></app-side-nav>

    <div class="layout-page">
      <div class="container mt-4">
        <div class="card">

          <div class="card-body">
            <div [formGroup]="multiForm" class="form-container bg-footer-theme p-3">


              <div>
                <button type="button" class="btn btn" (click)="goBack()" style="color: blue;" >
                    <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;"> Back
                </button>
                <div class="d-flex justify-content-end mt-3">
                  <button class="btn btn-success" 
                          [routerLink]="['/exportexcel', studyId]">
                    Export
                  </button>
                </div>
                

            </div>


              <!-- Dropdown to Select Option -
              <div class="row mb-3">
                <label for="optionSelect" class="col-sm-2 col-form-label">Select Option:</label>
                <div class="col-sm-3">
                  <select id="optionSelect" formControlName="selectedOption" class="form-select">
                    <option *ngFor="let siteActivity of siteActivitesList" [value]="siteActivity.name">
                      {{ siteActivity.name }}
                    </option>
                  </select>
                </div>
              </div>--><!-- Tabs for Option Selection -->
              <!-- Tabs for Option Selection -->
            <ul class="nav nav-tabs" role="tablist" >
              <li class="nav-item" role="presentation" *ngFor="let siteActivity of siteActivitesList">
                <a class="nav-link"
                  [class.active]="currentFormIndex === siteActivity.name" 
                  (click)="selectOption(siteActivity.name)" 
                  role="tab">
                  {{ siteActivity.name }}
                </a>
              </li>
            </ul>
              <div *ngIf="currentFormIndex == 'Site Monitoring Report'" formGroupName="Site_Monitoring_Report">
                <div formGroupName="form1">
                  <h5>Site Monitoring Report 1</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 1</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <!-- New Field for Report Link -->
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 1</label>
                      <div class="col-sm-3">
                        <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                      
                      </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 1</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Site_Monitoring_Report.form1.comment').invalid && multiForm.get('Site_Monitoring_Report.form1.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form2">
                  <h5>Site Monitoring Report 2</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 2</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 2</label>
                      <div class="col-sm-3">
                        <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                      
                      </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 2</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Site_Monitoring_Report.form2.comment').invalid && multiForm.get('Site_Monitoring_Report.form2.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form3">
                  <h5>Site Monitoring Report 3</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 3</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 3</label>
                      <div class="col-sm-3">
                        <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                      
                      </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 3</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Site_Monitoring_Report.form3.comment').invalid && multiForm.get('Site_Monitoring_Report.form3.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form4">
                  <h5>Site Monitoring Report 4</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 4</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 4</label>
                      <div class="col-sm-3">
                        <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                      
                      </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 4</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Site_Monitoring_Report.form4.comment').invalid && multiForm.get('Site_Monitoring_Report.form4.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form5">
                  <h5>Site Monitoring Report 5</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 5</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 5</label>
                      <div class="col-sm-3">
                        <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                      
                      </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 5</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="300" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Site_Monitoring_Report.form5.comment').invalid && multiForm.get('Site_Monitoring_Report.form5.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                  
                </div><div class="row">
                    <div class="col-sm-3 offset-sm-2">
                      <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                    </div>
                  </div>
              </div>
              <div *ngIf="currentFormIndex == 'CAPA Report'" formGroupName="CAPA_Report">
                <div formGroupName="form1">
                  <h5>CAPA Report 1</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 1</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <!-- New Field for Report Link -->
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 1</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 1</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('CAPA_Report.form1.comment').invalid && multiForm.get('CAPA_Report.form1.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form2">
                  <h5>CAPA Report 2</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 2</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 2</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 2</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('CAPA_Report.form2.comment').invalid && multiForm.get('CAPA_Report.form2.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form3">
                  <h5>CAPA Report 3</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 3</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 3</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 3</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('CAPA_Report.form3.comment').invalid && multiForm.get('CAPA_Report.form3.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form4">
                  <h5>CAPA Report 4</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 4</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 4</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 4</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('CAPA_Report.form4.comment').invalid && multiForm.get('CAPA_Report.form4.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form5">
                  <h5>CAPA Report 5</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 5</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 5</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 5</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('CAPA_Report.form5.comment').invalid && multiForm.get('CAPA_Report.form5.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                  
                </div><div class="row">
                    <div class="col-sm-3 offset-sm-2">
                      <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                    </div>
                  </div>
              </div>
              <div *ngIf="currentFormIndex == 'Monitoring close out visits'" formGroupName="Monitoring_close_out_visits">
                <div formGroupName="form1">
                  <h5>Monitoring close out visits 1</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 1</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 1</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 1</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Monitoring_close_out_visits.form1.comment').invalid && multiForm.get('Monitoring_close_out_visits.form1.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form2">
                  <h5>Monitoring close out visits 2</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 2</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 2</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 2</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Monitoring_close_out_visits.form2.comment').invalid && multiForm.get('Monitoring_close_out_visits.form2.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form3">
                  <h5>Monitoring close out visits 3</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 3</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 3</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 3</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Monitoring_close_out_visits.form3.comment').invalid && multiForm.get('Monitoring_close_out_visits.form3.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form4">
                  <h5>Monitoring close out visits 4</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 4</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 4</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 4</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Monitoring_close_out_visits.form4.comment').invalid && multiForm.get('Monitoring_close_out_visits.form4.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="form5">
                  <h5>Monitoring close out visits 5</h5>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date 5</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="reportLink" class="col-sm-2 col-form-label">Report Link 5</label>
                    <div class="col-sm-3">
                      <input id="reportLink" formControlName="reportLink" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="comment" class="col-sm-2 col-form-label">Comment 5</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" class="form-control" rows="5"  cols="60" style="resize: both; width: 500px;"></textarea>
                      <div
                        *ngIf="multiForm.get('Monitoring_close_out_visits.form5.comment').invalid && multiForm.get('Monitoring_close_out_visits.form5.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>